import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-mac',
  templateUrl: './driver-mac.component.html',
  styleUrls: ['./driver-mac.component.css']
})
export class DriverMacComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
